module.exports = __webpack_public_path__ + "static/media/icon-sign.b5912ecf.svg";